import { FallbackRenderer } from './fallback-renderer.js';
import { isWebGl2Supported } from './gl-context.js';
import { RENDERER_ERROR_CODES, } from './types.js';
import { WebGlRenderer } from './webgl-renderer.js';
export function createRenderer(options = {}) {
    return new AdaptiveRenderer(options);
}
/**
 * WebGL2 の可否で実装を切り替える薄いラッパ。
 *
 * **判定を `mount` まで遅らせる。** `isWebGl2Supported()` が true でも
 * 実際の取得が失敗することがある(メモリ不足・ドライバの問題)ため、
 * 取得を試みて駄目ならその場でフォールバックへ切り替える。
 */
class AdaptiveRenderer {
    options;
    delegate = null;
    constructor(options) {
        this.options = options;
    }
    mount(container, template, opts) {
        const fit = this.options.fit ?? 'contain';
        if (this.options.forceFallback !== true && isWebGl2Supported()) {
            const webgl = new WebGlRenderer(fit, this.options.emptyCellHint);
            try {
                webgl.mount(container, template, opts);
                this.delegate = webgl;
                return;
            }
            catch {
                // 中途半端に作られた DOM とコンテキストを片付けてから落とす。
                webgl.destroy();
            }
        }
        const fallback = new FallbackRenderer(fit, this.options.fallbackOutlines ?? true);
        fallback.mount(container, template, opts);
        this.delegate = fallback;
        opts.onError({ code: RENDERER_ERROR_CODES.UNSUPPORTED, recoverable: false });
    }
    maxSourceSize() {
        return this.delegate?.maxSourceSize() ?? 0;
    }
    setSource(frameId, cellIndex, source) {
        this.delegate?.setSource(frameId, cellIndex, source);
    }
    setTemplate(template) {
        this.delegate?.setTemplate(template);
    }
    setHighlight(ids) {
        this.delegate?.setHighlight(ids);
    }
    resize() {
        this.delegate?.resize();
    }
    setPaused(paused) {
        this.delegate?.setPaused(paused);
    }
    destroy() {
        this.delegate?.destroy();
        this.delegate = null;
    }
}
//# sourceMappingURL=create.js.map